module.exports = __webpack_public_path__ + "img/life-page1-img-1.a0ad64f2.jpg";